"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiResponseEnvelope = exports.apiResponseFactory = void 0;
const Factory = require("factory.ts");
const factories_1 = require("../../UserService/factories");
exports.apiResponseFactory = Factory.Sync.makeFactory({
    metadata: {
        current_user: factories_1.currentUserFactory.build(),
        trace_id: 'test-1234',
    },
    result: {}
});
const apiResponseEnvelope = (result) => {
    const response = exports.apiResponseFactory.build();
    response.result = result;
    return response;
};
exports.apiResponseEnvelope = apiResponseEnvelope;
